module.exports = __webpack_public_path__ + "static/img/2012.25aa56d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/events/2012.png
// module id = aoAN
// module chunks = 1